import clsx from "clsx";
import { useGetProperties } from "../../../base/hooks";
import { IControlAttributes } from "../../../base/models";
import { Registry } from "../../../base/register";
import { ControlType, Property } from "../../../base/types";
import { TouUmsLinkProperties } from "./properties/TouUmsLinkProperties";
import { useUmsUrl } from "../../page-actions/services/useTouUrl";


export const UMSLinkComponent = (props: IControlAttributes) => {
    const { control } = props;
    const { properties } = useGetProperties({ bindings: control.bindings });
    const { umsUrl } = useUmsUrl()
    const target: string | undefined = properties[Property.Target];
    const title: string | undefined = properties[Property.Title];

    if (!umsUrl)
        return <></>

    return (
        <>
            <div className={'menu-item'}>
                <a target={target || undefined} className={clsx('menu-link without-sub')} href={umsUrl}>
                <span className='menu-title'>{title}</span>
                </a>

            </div>
        </>
    );
};

Registry.addControl({
    id: "c857b558-92b2-4ee8-a2aa-a2eb2e905880",
    name: "UMSLinkComponent",
    type: ControlType.UMSLink,
    properties: TouUmsLinkProperties,
    component: UMSLinkComponent,
})

